import React from 'react';
import { Layout, LayoutItem } from '@axiom/ui';
import type { User } from '@axiom/validation';

import { ReputationDetails } from '../ReputationDetails/ReputationDetails';

export const WorkspaceTalentFeedback = ({
  name,
  userId,
}: {
  name: string;
  userId: User['id'];
}) => {
  return (
    <Layout stretched direction="vertical" name={name}>
      <LayoutItem stretched topGutter="24px">
        <ReputationDetails
          name="REPUTATION_DETAILS"
          userId={userId}
          withSearch
          withCount
          viewedIn="talent-detail"
        />
      </LayoutItem>
    </Layout>
  );
};
